import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  titleIconContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  desc: theme => ({
    marginTop: 19,
    marginBottom: 15,
    color: theme.colors.textColorNine,
    fontSize: 16,
  }),
  title: theme => ({
    fontSize: 16,
    fontWeight: 'bold',
    color: theme.colors.rememberMeText,
    marginRight: 8,
  }),
  iconImage: {
    width: 24,
    height: 24,
  },
});
